<div class="dialog-header">
  <h2 mat-dialog-title class="dialog-title">New export request</h2>
  <p class="dialog-subtitle">Choose the project to raise this export request on.</p>
</div>

<mat-dialog-content class="dialog-content">
  <app-error-banner [message]="errorMessage()" />

  <mat-form-field appearance="outline" class="project-field">
    <mat-label>Project</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input
      matInput
      [(ngModel)]="selection"
      name="selection"
      [matAutocomplete]="auto"
      placeholder="Search by name or code"
    />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayProject" panelClass="project-autocomplete-panel">
      @for (p of filteredProjects; track p.id) {
        <mat-option [value]="p">
          <div class="project-option">
            <span class="project-option__code">{{ p.code }}</span>
            <span class="project-option__name">{{ p.name }}</span>
          </div>
        </mat-option>
      } @empty {
        <mat-option disabled class="no-match-option">No matching projects found.</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <p class="field-status">
    @if (isLoading()) {
      Loading projects…
    } @else if (projects().length === 0) {
      No active projects. A paused or cancelled project can't take new export requests.
    } @else {
      {{ projects().length }} active {{ projects().length === 1 ? 'project' : 'projects' }} to choose from
    }
  </p>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-stroked-button class="btn-cancel" (click)="cancel()">Cancel</button>
  <button mat-flat-button class="btn-submit" (click)="submit()" [disabled]="!canSubmit">Continue</button>
</mat-dialog-actions>
